<div #textTooltip
     class="text-tooltip"
     [class.wide]="wide"
     [ngClass]="'position-' + positionType.toString().toLowerCase()"
     [@appear]="{ value: '', params: { delay: data.delay }}"
>
  {{ text }}
</div>
